import { useContext, useEffect, useState } from "react";
import { UserContext } from "../contexts/user";
import { GroupContext } from "../contexts/group";
import { Grid } from "@mui/material";
import { getGroupsByUserId, getisCompletedAssessmentTIM } from "../axios/axiosFunctions";
import WelcomeIntro from "./WelcomeIntro";
import GroupCard from "./GroupCard";
import { categoryForSlug } from "../utils/timFamily";

const TIMTeams = ({currentAssessment}) => {

    const {currentUser} = useContext(UserContext);
    const {currentGroup, setCurrentGroup,level,setLevel} = useContext(GroupContext);
    const [allGroups, setAllGroups] = useState([]);
    const [lastCompleted, setLastCompleted] = useState({last:"",pos:0});

    useEffect(() => {
      callGroups();
      localStorage.setItem("groupLL",JSON.stringify({group:currentGroup,level}));
    }, [])

    useEffect(() => {
        if(currentAssessment && currentGroup){
            checkIfComplete();
        }
    }, [currentAssessment,currentUser,currentGroup]);

    const checkIfComplete = async(groupId = currentGroup._id)=>{
        const isComplete = await getisCompletedAssessmentTIM(currentAssessment._id,currentUser._id,groupId);
        setLastCompleted(isComplete.slug);
        return isComplete;
    }

    const callGroups = async()=>{
        const res = await getGroupsByUserId(currentUser._id);
        setAllGroups(res.groups);
    }

    // Only show the teams that belong to THIS assessment's category. The TIM and
    // Executive assessments are the same family and a user can be in teams of
    // both (e.g. a TIM "senior" team and an Executive "member" team); without
    // this filter every TIM-family team showed up under every TIM-family
    // assessment card, so participants saw each team twice in the wrong section.
    const assessmentCategory = categoryForSlug(currentAssessment?.slug);
    const visibleGroups = assessmentCategory
        ? allGroups.filter((g) => g.category === assessmentCategory)
        : allGroups;

    const changeLevel = (newLevel,group)=>{
        setLevel(newLevel);
        setCurrentGroup(group);
        const storagedInfo = {
            group,
            level:newLevel
        };
        localStorage.setItem("groupLL",JSON.stringify(storagedInfo));
    }

    return (
    <>
    {
        level === 0 && 
        <Grid container spacing={{xs:2, sm:3, md:5}} sx={{marginTop:{xs:"24px", sm:"50px"}}}>
            {
                visibleGroups.map((g,i)=>(
                    <GroupCard key={i} group={g} changeLevel={changeLevel} checkIfComplete={checkIfComplete}/>
                ))
            }
        </Grid>
    }
    {
        level === 1 &&
        <WelcomeIntro introText={currentAssessment?.introText} mainImage={currentAssessment?.mainImage} slug={lastCompleted}/>
    }
    </>
    )
}

export default TIMTeams